import type { LogoutOtherDevicesResponse } from "@/types/sessions.ts";

/**
 * The one-line confirmation both clients show once "log out other devices"
 * returns. It reports what was found and ended, so a user with nothing else
 * logged in learns that rather than reading a success message that implies
 * otherwise.
 */
export function describeLogoutOtherDevices({
  endedSessions,
  revokedMcpTokens,
  revokedMachines,
}: LogoutOtherDevicesResponse) {
  const devices =
    endedSessions === 0
      ? "No other devices were logged in."
      : `Logged out of ${endedSessions} other ${endedSessions === 1 ? "device" : "devices"}.`;
  const parts = [devices];
  if (revokedMcpTokens > 0) parts.push("Your MCP clients were disconnected.");
  // Named separately from a device, because it is not the same repair job: a
  // computer has to be enrolled again before the assistant can reach it, and
  // someone told only that they were "logged out" would go looking for a login.
  if (revokedMachines > 0) {
    parts.push(
      revokedMachines === 1
        ? "Your computer was disconnected and needs connecting again."
        : `Your ${revokedMachines} computers were disconnected and need connecting again.`,
    );
  }
  return parts.join(" ");
}
